export function AtomIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M11.4102 10.2388C11.2297 10.4428 11.0403 10.6443 10.8423 10.8424C7.97846 13.7062 4.39053 14.7615 2.82843 13.1994C1.75749 12.1285 1.91676 10.1053 3.0456 8.01618M4.59307 5.81686C4.78088 5.60332 4.97844 5.39252 5.18545 5.18551C8.0493 2.32167 11.6372 1.26639 13.1993 2.82849C14.271 3.90016 14.1108 5.92532 12.9798 8.01602M10.8423 5.18551C13.7062 8.04936 14.7614 11.6373 13.1993 13.1994C11.6372 14.7615 8.0493 13.7062 5.18545 10.8424C2.32161 7.97852 1.26633 4.39059 2.82843 2.82849C4.39053 1.26639 7.97846 2.32167 10.8423 5.18551ZM8.66667 8.00002C8.66667 8.36821 8.36819 8.66668 8 8.66668C7.63181 8.66668 7.33333 8.36821 7.33333 8.00002C7.33333 7.63183 7.63181 7.33335 8 7.33335C8.36819 7.33335 8.66667 7.63183 8.66667 8.00002Z" stroke="#101828" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

AtomIcon.displayName = 'AtomIcon';
